import { Controller } from "@hotwired/stimulus";
import WebAuthnCodec from "../services/WebAuthnCodec";

export default class extends Controller {
  static targets = ["button", "status"];

  static values = { optionsUrl: String, callbackUrl: String };

  async authenticate() {
    this.setBusy(true);
    this.showError("");
    try {
      const optionsResponse = await fetch(this.optionsUrlValue, {
        headers: { Accept: "application/json" },
      });
      if (!optionsResponse.ok) throw new Error("options");
      const options = await optionsResponse.json();
      const publicKey = WebAuthnCodec.decodeRequestOptions(
        options.publicKey || options
      );
      const assertion = await navigator.credentials.get({ publicKey });
      if (!assertion) throw new Error("cancelled");
      const response = await fetch(this.callbackUrlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          credential: WebAuthnCodec.encodeAssertion(assertion),
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || "callback");
      if (!result.redirect_to) throw new Error("callback");
      window.location.assign(result.redirect_to);
    } catch (error) {
      this.showError(
        error.name === "NotAllowedError" || error.message === "cancelled"
          ? this.cancelledText()
          : this.failureText()
      );
      this.setBusy(false);
    }
  }

  setBusy(busy) {
    this.buttonTarget.disabled = busy;
    this.buttonTarget.setAttribute("aria-busy", busy);
  }

  showError(message) {
    this.statusTarget.textContent = message;
    this.statusTarget.hidden = !message;
    if (message) this.statusTarget.focus();
  }

  failureText() {
    return (
      this.element.dataset.passkeyAuthenticationFailureText ||
      "Passkey sign-in failed. Try again or use another method."
    );
  }

  cancelledText() {
    return (
      this.element.dataset.passkeyAuthenticationCancelledText ||
      "Passkey sign-in was cancelled. Choose another method."
    );
  }
}
